import Poll from '../components/Poll.vue'
import PageNotFound from '../components/PageNotFound.vue'
import Error from '../components/Error.vue'

const routes = [
  {
    path: '/:id',
    component: Poll
  },
  {
    path: '/pagenotfound',
    name: 'PageNotFound',
    component: PageNotFound
  },
  {
    path: '/error',
    name: 'Error',
    component: Error,
    props: true
  }
];

export default routes
